export default function MuiListItemIcon(theme) {
	return {
		root: {
			color: theme.palette.text.secondary,
			minWidth: '32px'
		}
	};
}
